import { render, staticRenderFns } from "./LoginPass.vue?vue&type=template&id=6879b13a&scoped=true&"
import script from "./LoginPass.vue?vue&type=script&lang=js&"
export * from "./LoginPass.vue?vue&type=script&lang=js&"
import style0 from "./LoginPass.vue?vue&type=style&index=0&id=6879b13a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879b13a",
  null
  
)

export default component.exports